var Backbone = require('backbone'),
    NoteSettings = require('../settings');

module.exports = Backbone.Model.extend({

    defaults: {
        pageFilter: 'all-pages',  // other is 'current-page' (possible values printed on view template)
        noteTypeFilter: 'all', // possible values: all existing note types; now based on groupNoteType: //TODO: reflect change in code but now have higher priority
        referralFilter: 'all', // possible values printed on view template

        hideActivityNotes: NoteSettings.prototype.defaults.hideActivityNotes,

        satFilterTxt: '',
        filterSrc: '', // dropdown, sat, pageChange, modeChange, noteDeleted, noteSaved
        currentPage: 1  //cache here -- don't get from each mode
    },


    dropDownFilter: function(options) {
        this.set({
            filterSrc: 'dropdown',
            pageFilter: options.page, //TODO: use the same name in the attr's and pick
            currentPage: options.currentPage, /* (pgNum) */
            noteTypeFilter: options.noteType,
            hideActivityNotes: options.hideActivityNotes,
            referralFilter: options.referralFilter
        });
    },

    satFilter: function(options) {
        this.set({
            filterSrc: 'sat',
            satFilterTxt: options.satFilterTxt,
            currentPage: options.currentPage
        });
    },

    updatePgNum: function(num) {
        this.set('currentPage', num);
    },
    setPageFilterToAllPgs: function() {
        this.set({
            pageFilter: 'all-pages'
        });
    },

    setHideActivityNotes: function(hideActivityNotes) {
        this.set('hideActivityNotes', hideActivityNotes);
    },

    isSourceSAT: function() {
        return this.get('filterSrc') === 'sat';
    },

    getSatTxt: function() {
        return this.get('satFilterTxt');
    },

    isCurrentPageFilterApplied: function() {
        return this.get('pageFilter') === 'current-page';
    },

    hideActivityNotes: function() {
        return this.get('hideActivityNotes');
    },
    /*
    * Return if a note model should be filter from the UI, given the state of the filter.
    * */
    shouldFilterNote: function(note) {

        var filterAttrs = this.toJSON(),
            consultGroupAssigned = note.consultGroupsAssigned(),

            showPage =  filterAttrs.pageFilter === 'all-pages' || filterAttrs.currentPage === note.pageNumber,
            showType =  filterAttrs.noteTypeFilter === 'all' || filterAttrs.noteTypeFilter === note.noteTypeGroup,
            showSAT =  note.textToFilter().toLowerCase().indexOf( filterAttrs.satFilterTxt.toLowerCase() ) > -1, //reg expr would be faster but would have to escape the text stored in var.
            showReferral =
                filterAttrs.referralFilter === 'all' ||
                ( filterAttrs.referralFilter === 'referred' && consultGroupAssigned ) ||
                ( filterAttrs.referralFilter === 'not-referred' && !consultGroupAssigned ),
            showNote = showPage && showType && showSAT && showReferral;

        if ( note.isActivityNote() && filterAttrs.hideActivityNotes )
            showNote = false;

        /* allow notes not of the filter type to display in the collection view so they can be created */
        if ( note.isNew())
            showNote = true;

        return !showNote;
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/state/filterState.js
 ** module id = 272
 ** module chunks = 0
 **/